import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import Interaction from "../../models/interactions/Interaction";
import { stripFormattingTags } from "../rich_text/RichTextHtmlUtils";
import { StringUtils } from "../utils/StringUtils";

type GetAdvancedSearchMatchingResultsParams = {
  searchableStrings: string[];
  query: string;
  interaction: Interaction;
  takeName: string;
  getValue: (key: string) => string;
  filterType: string;
  objectIdPrefix?: string;
};

export function getAdvancedSearchMatchingResults({
  searchableStrings,
  query,
  interaction,
  takeName,
  getValue,
  filterType,
  objectIdPrefix = interaction.id,
}: GetAdvancedSearchMatchingResultsParams): SearchResultData[] {
  const results: SearchResultData[] = [];

  searchableStrings.forEach((searchableString, index) => {
    // Rich text values contain formatting tags; match and display plain text.
    const localizedString = stripFormattingTags(
      getValue(searchableString) || searchableString
    );

    if (StringUtils.IsMatching(localizedString, query)) {
      results.push({
        objectId: `${objectIdPrefix}${index}`,
        matchingText: localizedString,
        filterType,
        interactionId: interaction.id,
        takeName,
        interactionType: interaction.type,
      });
    }
  });

  return results;
}
